module.exports = __webpack_public_path__ + "img/exe.e0f347e2.png";